import { useMemo, useState } from "react";
import { ChevronRight, ChevronDown, Folder, FileText, Trash2, CheckCircle2, XCircle, Circle } from "lucide-react";

export default function CaseTree({ cases, loading, selectedId, onSelect, onDelete }) {
  // Group by mahkeme_adi
  const groups = useMemo(() => {
    const m = {};
    for (const c of cases) {
      const k = c.mahkeme_adi || "Belirsiz Mahkeme";
      if (!m[k]) m[k] = [];
      m[k].push(c);
    }
    return Object.entries(m).sort(([a], [b]) => a.localeCompare(b, "tr"));
  }, [cases]);

  const [open, setOpen] = useState({});
  const toggle = (k) => setOpen((o) => ({ ...o, [k]: !o[k] }));

  if (loading) return <div className="text-slate-500 text-sm px-3 py-2">Yükleniyor...</div>;
  if (!cases.length) return <div className="text-slate-500 text-sm px-3 py-6 text-center">Henüz dava yok</div>;

  const resultIcon = (r) => {
    if (r === "basarili") return <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500" />;
    if (r === "basarisiz") return <XCircle className="w-3.5 h-3.5 text-red-500" />;
    return <Circle className="w-3.5 h-3.5 text-slate-500" />;
  };

  return (
    <div className="space-y-1" data-testid="case-tree">
      {groups.map(([mahkeme, list]) => {
        const expanded = open[mahkeme] !== false; // default open
        return (
          <div key={mahkeme} className="select-none">
            <div
              className="flex items-center gap-1.5 py-1.5 px-2 cursor-pointer rounded hover:bg-slate-800/60"
              onClick={() => toggle(mahkeme)}
              data-testid={`tree-court-${mahkeme.replace(/\s+/g, "-")}`}
            >
              {expanded ? <ChevronDown className="w-3.5 h-3.5 text-slate-400" /> : <ChevronRight className="w-3.5 h-3.5 text-slate-400" />}
              <Folder className="w-3.5 h-3.5 text-amber-500" />
              <span className="text-xs text-slate-300 font-medium truncate" title={mahkeme}>{mahkeme}</span>
              <span className="ml-auto text-[10px] font-mono text-slate-500">{list.length}</span>
            </div>
            {expanded && (
              <div className="ml-4 border-l border-slate-800 pl-2 space-y-0.5">
                {list.map((c) => (
                  <div
                    key={c.id}
                    className={`tree-node group ${selectedId === c.id ? "active" : ""}`}
                    onClick={() => onSelect(c)}
                    data-testid={`tree-case-${c.id}`}
                  >
                    <FileText className="w-3.5 h-3.5 text-slate-400 shrink-0" />
                    <div className="flex-1 min-w-0">
                      <div className="tree-node-title text-slate-200 truncate font-mono text-[12px]">{c.dava_no}</div>
                      <div className="text-[10px] text-slate-500 truncate">{c.muvekkil || "—"}</div>
                    </div>
                    {resultIcon(c.result)}
                    <button
                      className="opacity-0 group-hover:opacity-100 text-slate-500 hover:text-red-500 transition"
                      onClick={(e) => { e.stopPropagation(); onDelete(c.id); }}
                      aria-label="sil"
                      data-testid={`tree-delete-${c.id}`}
                    >
                      <Trash2 className="w-3.5 h-3.5" />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
